import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { UserService } from '../services';

@Pipe({
  name: 'datePreference',
  standalone: true
})
export class DatePreferencePipe implements PipeTransform {

  constructor(public userService: UserService) { }

  transform(value?: Date | null, showTime: boolean = false): string | null {
    try {
      const settings = this.userService.getSettings();
      const settingsKeys: string[] = Object.keys(settings);

      var dateFormat: string = "d MMM yyyy";

      if (settingsKeys.includes("general.dateformat")) {
        dateFormat = settings["general.dateformat"];
      }

      if (showTime) {
        dateFormat = dateFormat + " HH:mm:ss";
      }

      if (value) {
        return formatDate(value, dateFormat, "en-US");
      }
    }
    catch
    {
      // unable to transform so ignore error and continue
      return null;
    }

    return null;
  }

}
